import { PropertyType, PropertyCriteria } from '../types/property';

export const propertyTypes: PropertyType[] = [
  'apartment',
  'house',
  'promotion',
  'land',
  'commercial'
] as const;

export const propertyTypeLabels: Record<PropertyType, string> = {
  apartment: 'Appartement',
  house: 'Maison',
  promotion: 'Promotion',
  land: 'Terrain',
  commercial: 'Commerce'
} as const;

export const apartmentTypes = [
  'Simple',
  'Duplex',
  'Triplex',
  'Loft',
  'Studio',
  'Penthouse',
] as const;

export const houseTypes = [
  'Villa',
  'Maison de Luxe',
  'Maison de ville',
] as const;

export const conditions = [
  'Neuf',
  'Rénové à neuf',
  'Rénové',
  'Ancien',
  'À rénover',
  'Bon état',
  'Moyen état',
  'Mauvais état',
  'Très bon état',
  'Carcasse',
] as const;

export const views = [
  'Vue dégagée',
  'Vue mer',
  'Vue montagne',
  'Vue sur cour',
  'Vue sur jardin',
  'Vue sur ville',
] as const;

export const kitchenTypes = [
  'Aménagée',
  'Équipée',
  'Américaine / Ouverte',
  'Semi-ouverte',
  'Fermée',
  'Indépendante',
  'Cuisine avec îlot central',
  'Coin cuisine',
  'Sans cuisine',
  'À aménager',
] as const;